import { Injectable } from '@angular/core';
// import { CPMemberService } from './cp-member/services/CPMember.service';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  corpName = '';
  employee_id = '';
  constructor() {
    // private cpMemberService : CPMemberService
    window.dataLayer = window.dataLayer || [];
    // this.cpMemberService.getMemberOrHrCorporate().then(cor => {
    //     this.corpName = cor.name;
    //   });
  }


   formatIfDate(value) {
    const date = new Date(value);

    if (!isNaN(date.getTime())) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); 
        const year = date.getFullYear();

        return `${day}${month}${year}`; 
    }

    return value.toString();
}

  maskData(value: string): string {
    if (!value) return value;

    value = this.formatIfDate(value);
    if (value.includes('@')) {
      const [local, domain] = value.split('@');

      const visibleLength = Math.ceil(local.length * 0.3);
      const visiblePart = local.substring(0, visibleLength);
      const maskedPart = '*'.repeat(local.length - visibleLength);

      return `${visiblePart}${maskedPart}@${domain}`;
    }

    const visibleLength = Math.ceil(value.length * 0.3);
    const visiblePart = value.substring(0, visibleLength);
    const maskedPart = '*'.repeat(value.length - visibleLength);

    return visiblePart + maskedPart;
  }

pushEvent(eventName: string, properties: any = {}) {

  const fieldsToMask = ["policy_no",
"employee_id",
"family_member_name",
"mobile_number",
"email_id",
"DOB",
"name",
"email",
"nominee_percentage_share",
"pan",
"claiming_person",
"hospital_name",
"date_of_admission",
"date_of_discharge",
"claim_amount",
"abha_id",
"abha_address",
"claim_intimation",
]; 
  const maskedProperties: any = {};

  Object.keys(properties).forEach(key => {
    if (fieldsToMask.includes(key)) {
      maskedProperties[key] = this.maskData(properties[key]); 
    } else {
      maskedProperties[key] = properties[key]; 
    }
  });

  window.dataLayer.push({
    event: eventName,
    account: this.corpName,
    employee_id: this.employee_id,
    ...maskedProperties
  });
}
}
